import { render, staticRenderFns } from "./ICMLink.vue?vue&type=template&id=8e31473e&scoped=true&"
import script from "./ICMLink.vue?vue&type=script&lang=ts&"
export * from "./ICMLink.vue?vue&type=script&lang=ts&"
import style0 from "./ICMLink.vue?vue&type=style&index=0&id=8e31473e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e31473e",
  null
  
)

export default component.exports